import * as React from 'react';

interface IUserMenuDividerProps {
    isStrong?: boolean;
}

export const NavbarNavMenuUserMenuDivider = (props: IUserMenuDividerProps) => (
    <li role="presentation" className={`divider ${props.isStrong ? 'divider-strong' : ''}`} />
);
